import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaStar } from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

function ProjectItem({ image, name, projectId, tagline, technologies, featured, status }) {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = translations[language].projectDisplay;

  const open = () => navigate("/project/" + projectId);

  return (
    <motion.div
      className={`projectItem glass ${featured ? 'featured' : ''}`}
      onClick={open}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } }}
      role="link"
      tabIndex={0}
      aria-label={name}
      whileHover={{ scale: 1.03, y: -5 }}
      whileTap={{ scale: 0.98 }}
    >
      {featured && (
        <div className="featured-badge">
          <FaStar /> {t.featuredBadge}
        </div>
      )}
      {status && <div className="project-status-badge">{status}</div>}
      <div
        style={{
          backgroundImage: image ? `url(${image})` : 'linear-gradient(135deg, #6c63ff 0%, #ff6584 100%)',
          backgroundColor: !image ? '#1a1a2e' : 'transparent'
        }}
        className="bgImage"
      >
        {!image && (
          <div className="placeholder-content">
            <span className="placeholder-icon">🚀</span>
          </div>
        )}
      </div>
      <div className="projectItem-info">
        <h1>{name}</h1>
        {tagline && <p className="projectItem-tagline">{tagline}</p>}
        {technologies && technologies.length > 0 && (
          <div className="projectItem-tech">
            {technologies.slice(0, 4).map((tech) => (
              <span key={tech} className="tech-chip">{tech}</span>
            ))}
          </div>
        )}
      </div>
    </motion.div>
  )
}

export default ProjectItem;
